// extracted by mini-css-extract-plugin
export default {"page":"gZ-z","cartModal":"hZ-z","checkout":"iZ-z","placeholder":"jZ-z","account":"kZ-z"};